import React, { createContext, useContext, useState } from "react";

export const translations = {
  en: {
    appTitle: "Kirana Store Inventory",
    tagline: "One system. Every product. Every location. Real-time.",
    dashboard: "Dashboard",
    procurement: "Procurement",
    receiving: "Receiving / GRN",
    inventory: "Inventory Catalog",
    warehouse: "Warehouses & Bins",
    stockTransfer: "Stock Transfer",
    sales: "Sales & POS",
    retailPOS: "Retail POS Counter",
    wholesaleSales: "Wholesale Bulk Desk",
    customers: "Customer Accounts",
    suppliers: "Suppliers & Vendors",
    finance: "Finance & Accounts",
    employees: "Staff & Payroll",
    batchExpiry: "Batch & Expiry Watch",
    deadStock: "Dead Stock & Reorder",
    returns: "Returns & Damages",
    analytics: "Reports & Analytics",
    notifications: "Alerts & Tasks",
    auditLog: "Audit Trail",
    accessControl: "Role & Access Control",
    settings: "Settings",
    totalSales: "Total Sales",
    totalPurchases: "Total Purchases",
    grossProfit: "Gross Profit",
    margin: "Gross Margin",
    totalStockValue: "Total Stock Value",
    lowStockItems: "Low Stock Items",
    expiringSoon: "Expiring Soon",
    deadStockValue: "Dead Stock Value",
    outstandingReceivables: "Receivables (Customers)",
    outstandingPayables: "Payables (Suppliers)",
    searchProduct: "Search product across all warehouses (Type product name or barcode)...",
    searchPlaceholder: "Search...",
    createPO: "Create Purchase Order",
    receiveStock: "Receive GRN Putaway",
    newSale: "New Sale",
    transferStock: "Transfer Stock",
    exportCSV: "Export CSV",
    filter: "Filter",
    status: "Status",
    actions: "Actions",
    currency: "₹"
  },
  hi: {
    appTitle: "किराना स्टोर इन्वेंटरी",
    tagline: "एक सिस्टम। हर उत्पाद। हर स्थान। रीयल-टाइम।",
    dashboard: "डैशबोर्ड",
    procurement: "खरीद (प्रोक्योरमेंट)",
    receiving: "माल प्राप्ति (GRN)",
    inventory: "स्टॉक सूची (इन्वेंटरी)",
    warehouse: "गोदाम और रैक-बिन",
    stockTransfer: "स्टॉक ट्रांसफर",
    sales: "बिक्री और POS",
    retailPOS: "खुदरा काउंटर POS",
    wholesaleSales: "थोक बिक्री डेस्क",
    customers: "ग्राहक खाते",
    suppliers: "सप्लायर्स और व्यापारी",
    finance: "वित्त और हिसाब-किताब",
    employees: "कर्मचारी और वेतन",
    batchExpiry: "बैच और एक्सपायरी",
    deadStock: "डेड स्टॉक और री-ऑर्डर",
    returns: "वापसी और नुकसान",
    analytics: "रिपोर्ट और आंकड़े",
    notifications: "अलर्ट और सूचनाएं",
    auditLog: "ऑडिट लॉग",
    accessControl: "भूमिका और अधिकार",
    settings: "सेटिंग्स",
    totalSales: "कुल बिक्री",
    totalPurchases: "कुल खरीदारी",
    grossProfit: "सकल लाभ (मुनाफा)",
    margin: "मार्जिन %",
    totalStockValue: "कुल स्टॉक मूल्य",
    lowStockItems: "कम स्टॉक सामान",
    expiringSoon: "जल्द समाप्त (एक्सपायरी)",
    deadStockValue: "डेड स्टॉक मूल्य",
    outstandingReceivables: "ग्राहकों से बकाया",
    outstandingPayables: "सप्लायर का बकाया",
    searchProduct: "सभी गोदामों में उत्पाद खोजें...",
    searchPlaceholder: "खोजें...",
    createPO: "नया खरीद आर्डर बनाएं",
    receiveStock: "माल प्राप्ति दर्ज करें",
    newSale: "नई बिक्री",
    transferStock: "स्टॉक भेजें",
    exportCSV: "CSV डाउनलोड",
    filter: "फ़िल्टर",
    status: "स्थिति",
    actions: "कार्रवाई",
    currency: "₹"
  },
  mr: {
    appTitle: "किराणा स्टोअर इन्व्हेंटरी",
    tagline: "एकच प्रणाली. प्रत्येक वस्तू. प्रत्येक जागा. रिअल-टाइम.",
    dashboard: "डॅशबोर्ड",
    procurement: "खरेदी व्यवस्थापन",
    receiving: "माल आवक (GRN)",
    inventory: "वस्तू साठा (इन्व्हेंटरी)",
    warehouse: "गोदाम आणि रॅक रचना",
    stockTransfer: "माल हस्तांतरण",
    sales: "विक्री आणि बिलिंग",
    retailPOS: "किरकोळ विक्री POS",
    wholesaleSales: "घाऊक विक्री डेस्क",
    customers: "ग्राहक खाती",
    suppliers: "पुरवठादार / व्यापारी",
    finance: "आर्थिक हिशोब",
    employees: "कर्मचारी आणि पगार",
    batchExpiry: "बॅच व एक्सपायरी",
    deadStock: "पडून राहिलेला माल",
    returns: "परतावा व नुकसान",
    analytics: "अहवाल व विश्लेषण",
    notifications: "सूचना व इशारे",
    auditLog: "तपासणी नोंद",
    accessControl: "अधिकार व्यवस्थापन",
    settings: "सेटिंग्ज",
    totalSales: "एकूण विक्री",
    totalPurchases: "एकूण खरेदी",
    grossProfit: "एकूण नफा",
    margin: "नफ्याचे प्रमाण %",
    totalStockValue: "एकूण साठ्याचे मूल्य",
    lowStockItems: "कमी साठा असलेल्या वस्तू",
    expiringSoon: "मुदत संपत आलेला माल",
    deadStockValue: "अडकून पडलेले मूल्य",
    outstandingReceivables: "ग्राहकांकडून येणे बाकी",
    outstandingPayables: "व्यापाऱ्यांना देणे बाकी",
    searchProduct: "सर्व गोदामांमध्ये वस्तू शोधा...",
    searchPlaceholder: "शोधा...",
    createPO: "नवीन खरेदी ऑर्डर",
    receiveStock: "माल आवक नोंदवा",
    newSale: "नवीन विक्री",
    transferStock: "माल पाठवा",
    exportCSV: "CSV निर्यात",
    filter: "फिल्टर",
    status: "स्थिती",
    actions: "कृती",
    currency: "₹"
  }
};

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("kirana_lang") || "en";
  });

  const changeLanguage = (newLang) => {
    if (translations[newLang]) {
      setLang(newLang);
      localStorage.setItem("kirana_lang", newLang);
    }
  };

  const t = (key) => {
    return (translations[lang] && translations[lang][key]) || translations.en[key] || key;
  };

  return (
    <I18nContext.Provider value={{ lang, changeLanguage, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
